// React for Website

import React from "react";
//outsource
import { Form, Input } from "antd";

//components

const StaffLastName = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="lastName"
      label="Last Name"
      rules={[
        {
          required: true,
          message: "Please input Last Name",
        },
        // {
        //   pattern: /^[A-Za-z ]+$/,
        //   message: "Alphabets only",
        // },
        {
          max: 32,
          message: "Max length cannot exceed 32 characters",
        },
      ]}
    >
      <Input placeholder="Please input Last Name" disabled={disabled} />
    </Form.Item>
  );
};

export default StaffLastName;
